import React from 'react';
import {
  Container,
  Row,
  Col,
  Button
} from 'reactstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';

const ExpectSection = () => {
  const eventFeatures = [
    {
      id: 1,
      icon: 'fa-solid fa-martini-glass-citrus',
      text: 'Welcome Cocktail'
    },
    {
      id: 2,
      icon: 'fa-solid fa-pen-to-square',
      text: 'Opening Notes'
    },
    {
      id: 3,
      icon: 'fa-solid fa-microphone',
      text: 'Special Guest Speaker'
    },
    {
      id: 4,
      icon: 'fa-regular fa-handshake',
      text: 'Speed Networking'
    },
    {
      id: 5,
      icon: 'fa-regular fa-comments',
      text: 'Panel Discussions'
    },
    {
      id: 6,
      icon: 'fa-solid fa-industry',
      text: 'Industry Recognition'
    },
    {
      id: 7,
      icon: 'fa-solid fa-utensils',
      text: 'Gala Dinner'
    }
  ];

  return (
    <section className="expect-section py-3 py-lg-5">
      <Container>
        <Row className="g-5">
          <Col lg={6}>
            <h2 className="fw-bold mb-3">What can you expect from the event?</h2>
            <p className="mb-4">
              Network with leaders, explore future trends, and gain actionable 
              insights from global experts. A day packed with innovation, discussions, and collaborations.
            </p>
            <Button 
              color="dark" 
              className="px-4 py-2 rounded-pill"
              href="/community"
            >
              Join Our Partner Program
            </Button>
          </Col>
          <Col lg={6} className='mt-4 mt-lg-5'>
            <ul className="list-unstyled features-list">
              {eventFeatures.map((feature) => (
                <li key={feature.id}>
                  <span>
                    <i className={feature.icon}></i>
                  </span> 
                  {feature.text}
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ExpectSection;